import { createContext, useContext, useState } from "react";

const translations = {
  en: {
    nav: { home: "Home", ventures: "Ventures", about: "About", contact: "Contact" },
    hero: {
      overline: "Hallomedics · Shanzu, Kenya",
      l1: "One umbrella.",
      l2: "Seven ventures.",
      l3: "Health for every home.",
      sub: "Hallomedics develops health apps and nurtures the KEDE family of businesses — where Kenya meets Denmark on the shores of Shanzu.",
      cta1: "Explore the ventures",
      cta2: "Get in touch",
      scroll: "Scroll",
    },
    marquee: ["KEDE-Rooms", "KEDE-Water", "KEDE-Cleaning", "KEDE-Clothes", "KEDE-Juice", "KEDE-Mobile-Juice", "KeDe-IT", "Kenya — Denmark", "Shanzu"],
    carousel: { overline: "The KEDE family in motion", explore: "Explore" },
    manifesto: {
      overline: "Our manifesto",
      title: "What we believe",
      chapters: [
        { num: "01", title: "Health, engineered", body: "Hallomedics builds health apps that put care within reach of every household — designed in constant dialogue between our Kenyan and Danish teams." },
        { num: "02", title: "Seven ventures, one promise", body: "Rooms, water, cleaning, clothes, juice and IT — every KEDE business exists to make daily life in Shanzu healthier and easier." },
        { num: "03", title: "Kenya meets Denmark", body: "KEDE stands for Kenya/Denmark: Danish structure and quality woven together with Kenyan warmth and hustle." },
        { num: "04", title: "Rooted in Shanzu", body: "We live where we work. Every venture is built, staffed and loved in Shanzu, on the Kenyan coast." },
      ],
    },
    ventures: {
      overline: "The KEDE family",
      title: "Seven ventures under one umbrella",
      sub: "Tap a venture to discover it.",
    },
    about: {
      overline: "Where we are",
      title: "Shanzu, on the Kenyan coast",
      body: "Hallomedics was born in Shanzu, on Mombasa's north coast. Under one umbrella we develop health apps — and run the KEDE family of everyday ventures. KEDE means Kenya/Denmark, our founding partnership: two countries, one standard of care.",
      stats: [
        { value: "07", label: "Ventures" },
        { value: "02", label: "Countries" },
        { value: "01", label: "Home" },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Let's talk",
      sub: "Questions, bookings, partnerships — write to us and the right KEDE team will reply.",
      name: "Name",
      email: "Email",
      venture: "Which venture?",
      ventureGeneral: "General / Hallomedics",
      message: "Message",
      send: "Send enquiry",
      sending: "Sending…",
      success: "Thank you! We'll be in touch soon.",
      error: "Something went wrong. Please try again.",
    },
    project: {
      back: "All ventures",
      featuresOverline: "What you get",
      cta: "Enquire about this venture",
      next: "Next venture",
      galleryTitle: "Selected work",
      gallerySub: "A selection of websites and campaigns we have designed and run.",
      catWebsite: "Website",
      catCampaign: "Campaign",
    },
    footer: {
      tagline: "One umbrella. Seven ventures. Health for every home.",
      venturesTitle: "Ventures",
      brandTitle: "Hallomedics",
      location: "Shanzu, Mombasa, Kenya",
      rights: "All rights reserved.",
    },
  },
  da: {
    nav: { home: "Hjem", ventures: "Virksomheder", about: "Om os", contact: "Kontakt" },
    hero: {
      overline: "Hallomedics · Shanzu, Kenya",
      l1: "Én paraply.",
      l2: "Syv virksomheder.",
      l3: "Sundhed til hvert hjem.",
      sub: "Hallomedics udvikler sundheds-apps og driver KEDE-familien af virksomheder — hvor Kenya møder Danmark ved kysten i Shanzu.",
      cta1: "Udforsk virksomhederne",
      cta2: "Kontakt os",
      scroll: "Rul",
    },
    marquee: ["KEDE-Rooms", "KEDE-Water", "KEDE-Cleaning", "KEDE-Clothes", "KEDE-Juice", "KEDE-Mobile-Juice", "KeDe-IT", "Kenya — Danmark", "Shanzu"],
    carousel: { overline: "KEDE-familien i bevægelse", explore: "Udforsk" },
    manifesto: {
      overline: "Vores manifest",
      title: "Det tror vi på",
      chapters: [
        { num: "01", title: "Sundhed, konstrueret", body: "Hallomedics bygger sundheds-apps, der bringer omsorg inden for rækkevidde af enhver husstand — designet i løbende dialog mellem vores kenyanske og danske teams." },
        { num: "02", title: "Syv virksomheder, ét løfte", body: "Værelser, vand, rengøring, tøj, juice og it — hver KEDE-virksomhed findes for at gøre hverdagen i Shanzu sundere og lettere." },
        { num: "03", title: "Kenya møder Danmark", body: "KEDE står for Kenya/Danmark: dansk struktur og kvalitet vævet sammen med kenyansk varme og arbejdsomhed." },
        { num: "04", title: "Forankret i Shanzu", body: "Vi bor, hvor vi arbejder. Hver virksomhed er bygget, bemandet og elsket i Shanzu på Kenyas kyst." },
      ],
    },
    ventures: {
      overline: "KEDE-familien",
      title: "Syv virksomheder under én paraply",
      sub: "Tryk på en virksomhed for at opdage den.",
    },
    about: {
      overline: "Hvor vi er",
      title: "Shanzu, på Kenyas kyst",
      body: "Hallomedics blev født i Shanzu på Mombasas nordkyst. Under én paraply udvikler vi sundheds-apps — og driver KEDE-familien af hverdagsvirksomheder. KEDE betyder Kenya/Danmark, vores grundlæggende partnerskab: to lande, én standard for omsorg.",
      stats: [
        { value: "07", label: "Virksomheder" },
        { value: "02", label: "Lande" },
        { value: "01", label: "Hjem" },
      ],
    },
    contact: {
      overline: "Kontakt",
      title: "Lad os tale sammen",
      sub: "Spørgsmål, bookinger, partnerskaber — skriv til os, og det rette KEDE-team vender tilbage.",
      name: "Navn",
      email: "E-mail",
      venture: "Hvilken virksomhed?",
      ventureGeneral: "Generelt / Hallomedics",
      message: "Besked",
      send: "Send forespørgsel",
      sending: "Sender…",
      success: "Tak! Vi vender tilbage snart.",
      error: "Noget gik galt. Prøv venligst igen.",
    },
    project: {
      back: "Alle virksomheder",
      featuresOverline: "Det får du",
      cta: "Forespørg om denne virksomhed",
      next: "Næste virksomhed",
      galleryTitle: "Udvalgt arbejde",
      gallerySub: "Et udpluk af hjemmesider og kampagner, vi har designet og kørt.",
      catWebsite: "Hjemmeside",
      catCampaign: "Kampagne",
    },
    footer: {
      tagline: "Én paraply. Syv virksomheder. Sundhed til hvert hjem.",
      venturesTitle: "Virksomheder",
      brandTitle: "Hallomedics",
      location: "Shanzu, Mombasa, Kenya",
      rights: "Alle rettigheder forbeholdes.",
    },
  },
  sw: {
    nav: { home: "Nyumbani", ventures: "Biashara", about: "Kuhusu", contact: "Wasiliana" },
    hero: {
      overline: "Hallomedics · Shanzu, Kenya",
      l1: "Mwavuli mmoja.",
      l2: "Biashara saba.",
      l3: "Afya kwa kila nyumba.",
      sub: "Hallomedics hutengeneza programu za afya na kulea familia ya biashara za KEDE — ambapo Kenya inakutana na Denmark pwani mwa Shanzu.",
      cta1: "Gundua biashara",
      cta2: "Wasiliana nasi",
      scroll: "Sogeza",
    },
    marquee: ["KEDE-Rooms", "KEDE-Water", "KEDE-Cleaning", "KEDE-Clothes", "KEDE-Juice", "KEDE-Mobile-Juice", "KeDe-IT", "Kenya — Denmark", "Shanzu"],
    carousel: { overline: "Familia ya KEDE inayotembea", explore: "Gundua" },
    manifesto: {
      overline: "Maono yetu",
      title: "Tunaamini nini",
      chapters: [
        { num: "01", title: "Afya, kwa ubunifu", body: "Hallomedics hujenga programu za afya zinazowafikia kila kaya — zimeundwa kwa ushirikiano wa karibu wa timu zetu za Kenya na Denmark." },
        { num: "02", title: "Biashara saba, ahadi moja", body: "Vyumba, maji, usafi, nguo, juisi na IT — kila biashara ya KEDE ipo kufanya maisha ya kila siku Shanzu yawe ya afya na rahisi." },
        { num: "03", title: "Kenya inakutana na Denmark", body: "KEDE ina maana ya Kenya/Denmark: mpangilio na ubora wa Denmark vimefumwa pamoja na ukarimu na bidii ya Kenya." },
        { num: "04", title: "Mizizi Shanzu", body: "Tunaishi tunapofanya kazi. Kila biashara imejengwa, imeajiri na imependwa Shanzu, pwani ya Kenya." },
      ],
    },
    ventures: {
      overline: "Familia ya KEDE",
      title: "Biashara saba chini ya mwavuli mmoja",
      sub: "Gusa biashara kuigundua.",
    },
    about: {
      overline: "Tulipo",
      title: "Shanzu, pwani ya Kenya",
      body: "Hallomedics ilizaliwa Shanzu, pwani ya kaskazini mwa Mombasa. Chini ya mwavuli mmoja tunatengeneza programu za afya — na kuendesha familia ya biashara za KEDE. KEDE ina maana ya Kenya/Denmark, ushirikiano wetu wa mwanzo: nchi mbili, kiwango kimoja cha huduma.",
      stats: [
        { value: "07", label: "Biashara" },
        { value: "02", label: "Nchi" },
        { value: "01", label: "Nyumbani" },
      ],
    },
    contact: {
      overline: "Wasiliana",
      title: "Hebu tuzungumze",
      sub: "Maswali, uhifadhi, ushirikiano — tuandikie na timu husika ya KEDE itakujibu.",
      name: "Jina",
      email: "Barua pepe",
      venture: "Biashara gani?",
      ventureGeneral: "Kwa ujumla / Hallomedics",
      message: "Ujumbe",
      send: "Tuma ujumbe",
      sending: "Inatuma…",
      success: "Asante! Tutawasiliana nawe hivi karibuni.",
      error: "Kuna hitilafu. Tafadhali jaribu tena.",
    },
    project: {
      back: "Biashara zote",
      featuresOverline: "Unachopata",
      cta: "Uliza kuhusu biashara hii",
      next: "Biashara inayofuata",
      galleryTitle: "Kazi zilizochaguliwa",
      gallerySub: "Baadhi ya tovuti na kampeni tulizobuni na kuendesha.",
      catWebsite: "Tovuti",
      catCampaign: "Kampeni",
    },
    footer: {
      tagline: "Mwavuli mmoja. Biashara saba. Afya kwa kila nyumba.",
      venturesTitle: "Biashara",
      brandTitle: "Hallomedics",
      location: "Shanzu, Mombasa, Kenya",
      rights: "Haki zote zimehifadhiwa.",
    },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("da");
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
